import axios from '@p/utils/request';
import api from '@/api';

//练习详情
export const getPracticeHistoryQuestionByPracticeId = (data) => {
	return axios.get(api.practice.getPracticeHistoryQuestionByPracticeId,{params:data})
}

//练习列表
export const getPracticeByIdLessonsId = (data) => {
	return axios.get(api.practice.getPracticeByIdLessonsId,{params:data})
}

//保存练习
export const savePractice = (data) => {
	return axios.post(api.practice.savePractice,data)
}